import React, {useEffect, useState} from "react";
import useWithStore from "@/Hooks/useWithStore";
import Svg from "@/Components/Svg";
import Checkbox from "@/Components/Checkbox";
import CheckBoxText from "@/Components/CheckBoxText";
import classNames from "classnames";
import {ClickAwayListener, TextField} from '@mui/material';

const FilterLayout = (props) => {
    const {
        filter = {},
        stores = {},
        modal = false,
        content = true,
        insertColors = {},
        isDesktop = false,
    } = props;
    const {
        dependencies = [],
        key = '',
        options = [],
        title = '',
        type = '',
        visible = false,
        visibleOptionsCount = 8,
    } = filter;

    const {catalogStore = {}, modalStore = {}} = stores;

    // // Состояние (элементы фильтра)
    // const [data, setData] = useState([]);
    // Состояние (отображает индикатор в процессе запроса на сервер)
    const [loader, setLoader] = useState('');
    // Состояние (кнопка "Показать все")
    const [showAllState, setShowAllState] = useState(false);
    // Состояние (элементы фильтра всплывашка)
    const [submenuState, setSubmenuState] = useState(false);
    // Состояние (диапазон)
    const [rangeState, setRangeState] = useState({
        value_min: 0,
        value_max: 0,
    });

    const dropdownFilter = classNames('dropdown-filter', props.className, {
        'modal': modal,
        'open': submenuState,
    });

    const arrowDown = classNames('svg__arrowDown', props.className, {
        'up': submenuState,
    });

    useEffect(() => {
        if (type === 'range') {
            if (!rangeState.value_min && !rangeState.value_max) {
                setRangeState({
                    value_min: options.selected_min ?? options.value_min,
                    value_max: options.selected_max ?? options.value_max,
                });
            }
        }
    }, []);

    useEffect(() => {
        // if (type !== 'range' && !showAllState) {
        //     setData([...options].slice(0, visibleOptionsCount));
        // } else {
        //     setData(options);
        // }

        if (loader) {
            setLoader('');
        }
    }, [options]);

    useEffect(() => {
        if (type === 'range' && catalogStore.filtersMap) {
            if (!options.selected_min && !options.selected_max) {
                if (!catalogStore.filtersMap.has(options.key)) {
                    if (rangeState.value_min !== options.value_min || rangeState.value_max !== options.value_max) {
                        setRangeState({
                            value_min: options.value_min,
                            value_max: options.value_max,
                        });
                    }
                }
            }
        }

        if (modalStore.filterStoreName !== '' && modalStore.filterStoreName === key) {
            modalStore.filter = options;
        }
    }, [options]);

    /**
     * Открыть/Закрыть меню фильтра
     */
    const changeContent = () => {
        if (modal) return;

        if (isDesktop) {
            setSubmenuState(!submenuState);
        } else {
            openFilterDrawer();
        }
    };

    /**
     * Открыть модалку "Детальный список конкретного фильтра"
     */
    const openFilterDrawer = () => {
        modalStore.openFilterDrawer(options, title, key, type, dependencies);
    };

    /**
     * Закрыть меню фильтра по клику вне области
     */
    const handleClickAway = () => {
        setSubmenuState(false);
    }

    /**
     * Обработка вводимого значения (диапазон)
     * @param event
     * @param variableName
     */
    const onChangeInput = (event, variableName) => {
        setRangeState(state => ({...state, [variableName]: Number(event.target.value)}));
    }

    /**
     * Обработка потери фокуса
     * @param variableName
     */
    const onBlur = (variableName) => {
        setLoader(' load');

        // Контрольные границы из props (определяются на сервере)
        const controlMin = options.value_min;
        const controlMax = options.value_max;

        setRangeState((prevState) => {
            let newState = {...prevState};
            if (variableName === 'value_min') {
                const isEmpty = !prevState.value_min || isNaN(prevState.value_min);
                const maxLimit = (prevState.value_max !== controlMax)
                    ? Math.min(prevState.value_max, controlMax)
                    : controlMax;

                const validMin = isEmpty ? controlMin : Math.max(controlMin, Math.min(prevState.value_min, maxLimit));

                newState.value_min = validMin;
            }

            if (variableName === 'value_max') {
                const isEmpty = !prevState.value_max || isNaN(prevState.value_max);
                const minLimit = (prevState.value_min !== controlMin)
                    ? Math.max(prevState.value_min, controlMin)
                    : controlMin;

                const validMax = isEmpty ? controlMax : Math.min(controlMax, Math.max(prevState.value_max, minLimit));
                newState.value_max = validMax;
            }

            // Дальнейшая обработка с корректными параметрами
            catalogStore.onBlur(newState, options);

            return newState;
        });
    }

    /**
     * Используется в фильтрах, общий метод (обработка radio, checkbox, range)
     * @param el
     */
    const onChangeCheckbox = (el) => {
        setLoader(' load');
        catalogStore.onChangeFilter(el, dependencies);
    }

    /**
     * Используется в фильтрах, общий метод (обработка radio, checkbox, range)
     * @param el
     */
    const onClickCustomCheckbox = (el) => {
        if (el.disabled) {
            return;
        }

        setLoader(' load');
        catalogStore.onChangeFilter(el, dependencies);
    }

    /**
     * Посмотреть все
     */
    const onChangeList = () => {
        setShowAllState(true);
        // setData(options);
    }

    // Не показываем фильтр, если ...
    if (!visible || (type !== 'range' && options.length === 0) || (type === 'range' && options.value_min === null && options.value_max === null)) return null;

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div className={dropdownFilter}>
                <div className={`dropdown-filter__name`} onClick={() => changeContent()}>
                    <p>{title}</p>
                    {isDesktop && !modal && (<Svg id={`arrowDown`} className={arrowDown} />)}
                    {!isDesktop && modal && (type !== 'range' && options.length > visibleOptionsCount) && (
                        <p className={`dropdown-filter__nameAll`} onClick={openFilterDrawer}>
                            Все
                        </p>
                    )}
                </div>
                {content && (
                    <div className={`dropdown-filter__content`}>
                        {type === 'range' ?
                            <div className={loader}>
                                <div className={`priceTextField`}>
                                    <TextField
                                        label={`От`}
                                        value={rangeState.value_min}
                                        onChange={(event) => onChangeInput(event, 'value_min')}
                                        onBlur={() => onBlur('value_min')}
                                    />
                                    <TextField
                                        label={`До`}
                                        value={rangeState.value_max}
                                        onChange={(event) => onChangeInput(event, 'value_max')}
                                        onBlur={() => onBlur('value_max')}
                                    />
                                </div>
                            </div>
                            :
                            <div className={`dropdown-filter__list${loader}`}>
                                {options.map((el, index) => {
                                    const className = classNames({
                                        'hidden': !showAllState && index >= visibleOptionsCount
                                    });

                                    if (isDesktop) {
                                        return <Checkbox
                                            key={el.id}
                                            name={el.valueAlias}
                                            value={el.valueAlias}
                                            disabled={el.disabled}
                                            checked={el.checked}
                                            className={className}
                                            onChange={() => onChangeCheckbox(el)}
                                            label={<CheckBoxText el={el} insertColors={insertColors} />}
                                            icon={
                                                el.type === 'radio' ?
                                                    <Svg id={`notCheckedRadio`} className={`svg__notCheckedRadio`} />
                                                    :
                                                    null
                                            }
                                            checkedIcon={
                                                el.type === 'radio' ?
                                                    <Svg id={`checkedRadio`} className={`svg__checkedRadio`} />
                                                    :
                                                    null
                                            }
                                        />
                                    } else {
                                        return <CustomCheckbox
                                            key={el.id}
                                            el={el}
                                            checked={el.checked}
                                            disabled={el.disabled}
                                            onClick={() => onClickCustomCheckbox(el)}
                                            insertColors={insertColors}
                                            className={className}
                                        />
                                    }
                                })}
                                {isDesktop && !showAllState && options.length > visibleOptionsCount && (
                                    <p className={`dropdown-filter__watchAll`} onClick={() => onChangeList()}>
                                        Посмотреть все
                                    </p>
                                )}
                            </div>
                        }
                    </div>
                )}
            </div>
        </ClickAwayListener>
    );
}

const CustomCheckbox = (props) => {
    const {
        el = {},
        checked = false,
        disabled = false,
        onClick = () => {
        },
        insertColors = {},
    } = props;

    const customCheckboxContainer = classNames('customCheckboxContainer', props.className, {
        'active': checked,
        'disabled': disabled,
    });

    return (
        <div className={customCheckboxContainer} onClick={onClick}>
            <p className={`customCheckboxContainer__text`}>
                <CheckBoxText el={el} insertColors={insertColors} />
            </p>
            {Boolean(checked) && (
                <div className={`customCheckboxContainer__icon`}>
                    <Svg id={`dagger-close`} className={`svg__dagger-close`} />
                </div>
            )}
        </div>
    );
}

export default useWithStore(FilterLayout);
